import React from 'react'
import { useMedia } from 'presentation/utils/window-media'
import SheetModalNew from 'presentation/shared/components/SheetModalNew'
import HeadingNew from 'presentation/shared/components/HeadingNew'
import * as S from './styles'
import SupportTextNew from '../SupportTextNew'
import ButtonNew from '../ButtonNew'
import { useStores } from 'presentation/hooks/use-stores'
import { observer } from 'mobx-react'

export type ResponsiveModalProps = {
  isOpen: boolean
  onClose: () => void
  title: string
  description: string
  children: React.ReactNode
}

const ResponsiveReviewSurgicalOrder = observer(
  ({ isOpen, onClose, title, description, children }: ResponsiveModalProps) => {
    const store = useStores().surgicalOrderV2
    const media = useMedia()

    const BackButtonMobile = (
      <ButtonNew size="large" onClick={onClose} style={{ fontSize: '14px' }}>
        Voltar para criação do pedido
      </ButtonNew>
    )

    if (media.md) {
      return (
        <>
          <S.Header>
            <HeadingNew weight="semiBold" size="medium" color="textSecondary">
              {title}
            </HeadingNew>
            <SupportTextNew
              color="textSecondary"
              fontFamily="secondary"
              style={{ marginTop: '8px', lineHeight: 1.4 }}
            >
              {description}
            </SupportTextNew>
          </S.Header>
          <S.Content>{children}</S.Content>
        </>
      )
    }

    return (
      <SheetModalNew
        isOpen={isOpen}
        onClose={onClose}
        title={title}
        size="auto"
        backdrop="true"
        primaryButton={BackButtonMobile}
      >
        {store.completedSteps?.length ? (
          <SupportTextNew
            size="xsmall"
            color="textSecondary"
            fontFamily="secondary"
            style={{ lineHeight: 1.4 }}
          >
            {description}
          </SupportTextNew>
        ) : null}
        <S.Content>{children}</S.Content>
      </SheetModalNew>
    )
  }
)

export default ResponsiveReviewSurgicalOrder
